export default from './EmbedCalculator';



// WEBPACK FOOTER //
// ./src/components/EmbedCalculator/index.js